const uppercase = (val) => ((typeof (val) === 'string') ? val.toUpperCase() : val);

export default uppercase;
